// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
import 'modernizr'

import Vue from 'vue'
import { sync } from 'vuex-router-sync'

import App from './App'
import i18n from './i18n'
import router from './router'
import store from './store'

import './plugins/baidu-tongji'
import './plugins/clickaway'
import './plugins/head'
import './plugins/google-analytics'
import './plugins/match-media'
import './plugins/parallax'
import './plugins/nprogress'
import './plugins/waypoint'

sync(store, router)

Vue.config.productionTip = false

async function boot () {
  await store.dispatch('setLocale', i18n.locale)
  await store.dispatch('loadLocaleMessages', i18n.fallbackLocale)

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    i18n,
    router,
    store,
    // template: '<App/>',
    components: { App },
    mq: {
      xs: '(min-width: 0px)',
      md: '(min-width: 768px)',
      xl: '(min-width: 1280px)'
    }
  })
}
boot()



// WEBPACK FOOTER //
// ./src/main.js